import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    getQuotation, quotationStatusChange
} from 'services/redux/sales/projectOnboarding/action';
import ApproveQuotation from './approveQuotations';

const mapStateToProps = (state) => ({
  quotation: state.projectOnboardingReducer.quotation
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getQuotation,
      quotationStatusChange
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ApproveQuotation);
